import { ReportLayout } from '../layout';

/**
 * The general procedure test report's layout: the sections legacy report
 * templates carry, in their order, each filled from the part of the procedure
 * the legacy templates drew it from. The general starter writes it out as a
 * bundle's layout.ts, to rearrange and extend in code.
 */
export function generalLayout(): ReportLayout {
  return {
    sections: [
      {
        id: 'introduction', title: 'Introduction', numbered: true, blocks: [
          { id: 'introduction', type: 'field', props: { label: 'Introduction', multiline: true, required: false }, whenEmpty: 'leave-out' },
          { id: 'introduction-readings', type: 'readings', props: { bucket: 'introduction', showStep: true }, whenEmpty: 'leave-out' },
          { id: 'introduction-figures', type: 'gallery', props: { bucket: 'introduction' }, whenEmpty: 'leave-out' },
        ],
      },
      { id: 'dut', title: 'DUT information', numbered: true, blocks: [{ id: 'dut', type: 'dut', props: {} }] },
      { id: 'facility', title: 'Facility', numbered: true, blocks: [{ id: 'facility', type: 'field', props: { label: 'Facility', multiline: true, required: false } }] },
      { id: 'test-information', title: 'Test information', numbered: true, blocks: [{ id: 'test-information', type: 'text', props: { text: '', fallback: 'procedure-description' } }] },
      { id: 'diagram', title: 'Test diagram schematic', numbered: true, blocks: [{ id: 'diagram', type: 'gallery', props: { bucket: 'diagram' } }] },
      {
        id: 'setup', title: 'Test setup', numbered: true, blocks: [
          { id: 'setup-figures', type: 'gallery', props: { bucket: 'setup' } },
          { id: 'equipment', type: 'equipment', props: {}, whenEmpty: 'leave-out' },
        ],
      },
      {
        id: 'parameters', title: 'Parameters', numbered: true, blocks: [
          { id: 'test-matrix', type: 'procedure-parameters', props: {}, whenEmpty: 'leave-out' },
          { id: 'parameters', type: 'readings', props: { bucket: 'parameters', showStep: true } },
        ],
      },
      { id: 'data', title: 'Test data', numbered: true, blocks: [{ id: 'data', type: 'steps', props: { bucket: 'data', exceptChecked: true } }] },
      { id: 'validation', title: 'Data validation', numbered: true, blocks: [{ id: 'validation', type: 'steps', props: { bucket: 'validation', exceptChecked: true } }] },
      { id: 'analysis', title: 'Analysis', numbered: true, blocks: [{ id: 'analysis', type: 'steps', props: { bucket: 'analysis', exceptChecked: true } }] },
      {
        id: 'conclusion', title: 'Conclusion', numbered: true, blocks: [
          { id: 'findings', type: 'findings', props: {} },
          { id: 'checks', type: 'checks', props: {}, whenEmpty: 'leave-out' },
          { id: 'verification', type: 'steps', props: { bucket: 'conclusion', exceptChecked: true }, whenEmpty: 'leave-out' },
          { id: 'conclusion', type: 'field', props: { label: 'Engineer’s conclusion', multiline: true, required: false } },
        ],
      },
      {
        id: 'appendix', title: 'Appendix', numbered: false, blocks: [
          { id: 'data-files', type: 'data-files', props: {}, whenEmpty: 'leave-out' },
          { id: 'attachments', type: 'gallery', props: { bucket: 'appendix', title: 'Attachments' }, whenEmpty: 'leave-out' },
          { id: 'figure-index', type: 'figure-index', props: {} },
        ],
      },
    ],
  };
}
